import { deleteData, getData, postData, putData } from "..";

export const GetAdminData = async (skip, take, search) => {
  try {
    const request = await getData(
      `/admin/user?skip=${skip}&take=${take}&search=${search}`
    );
    return request;
  } catch (error) {
    throw error;
  }
};

export const PostAdmin = async (data) => {
  try {
    const request = await postData(`/admin/user`, data);
    return request;
  } catch (error) {
    throw error;
  }
};

export const PutAdmin = async (id, data) => {
  try {
    const request = await putData(`/admin/user/${id}`, data);
    return request;
  } catch (error) {
    throw error;
  }
};

export const DeactivateAdmin = async (id) => {
  if (id) {
    try {
      const request = await deleteData(`/admin/user/deactivate/${id}`);
      return request;
    } catch (error) {
      throw error;
    }
  }
};
